<div class="chart-container">
    <canvas #canvas>{{chart}}</canvas>
</div>
